import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Badge, Col, Tabs } from "antd";
import AccountDetailsTab from "@Components/account/AccountDetailsTab";
import AccountOptionsTab from "@Components/account/AccountOptionsTab";
import AccountPrivacyTab from "@Components/account/AccountPrivacyTab";
import AccountSecurityTab from "@Components/account/AccountSecurityTab";
import "@Styles/pages/accountDetailsPage.scss";
import PageHelmet from "@Components/shared/PageHelmet";
import { useHistory } from "react-router-dom";
import { hasCapability } from "@Utils";
import { SystemContext } from "@Constants";
import AccountSystemTab from "@Components/account/AccountSystemTab";
import {
    FormatListBulleted,
    CheckCircleOutlined,
    VerifiedUserOutlined,
    LockOutlined,
    BuildOutlined,
} from "@mui/icons-material";

type AccountDetailsTabs = "#details" | "#security" | "#options" | "#privacy";
const AccountDetailsPage = () => {
    const [activeKey, setActiveKey] = useState<AccountDetailsTabs>("#details");
    const { hash } = useLocation();
    const history = useHistory();

    /**
     * Change the current navigation tab.
     * @param key
     */
    const handleTabChange = (key: AccountDetailsTabs) => {
        setActiveKey(key);
        history.push(`/account${key}`);
    };

    useEffect(() => {
        setActiveKey(hash as AccountDetailsTabs);
    }, [hash]);

    useEffect(() => {
        setActiveKey(hash as AccountDetailsTabs);
    }, []);

    return (
        <article className={"account-details-page"}>
            <PageHelmet name={"Accounts"} />
            <div className="account-details">
                <Tabs
                    tabPosition="left"
                    className="newUI-raised"
                    type="card"
                    activeKey={activeKey}
                    onChange={handleTabChange}
                >
                    <Tabs.TabPane
                        tab={
                            <>
                                <Badge>
                                    <FormatListBulleted />
                                </Badge>
                                Details
                            </>
                        }
                        key="#details"
                    >
                        <Col span={18}>
                            <AccountDetailsTab />
                        </Col>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={
                            <>
                                <Badge>
                                    <CheckCircleOutlined />
                                </Badge>
                                Options
                            </>
                        }
                        key="#options"
                    >
                        <Col span={18}>
                            <AccountOptionsTab />
                        </Col>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={
                            <>
                                <Badge>
                                    <VerifiedUserOutlined />
                                </Badge>
                                Security
                            </>
                        }
                        key="#security"
                    >
                        <Col span={18}>
                            <AccountSecurityTab />
                        </Col>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={
                            <>
                                <Badge>
                                    <LockOutlined />
                                </Badge>
                                Privacy & Terms
                            </>
                        }
                        key="#privacy"
                    >
                        <Col span={18}>
                            <AccountPrivacyTab />
                        </Col>
                    </Tabs.TabPane>
                    {hasCapability("Option/UpdateSystem", SystemContext) && (
                        <Tabs.TabPane
                            tab={
                                <Badge>
                                    <BuildOutlined />
                                    System
                                </Badge>
                            }
                            key="#system"
                        >
                            <Col span={18}>
                                <AccountSystemTab />
                            </Col>
                        </Tabs.TabPane>
                    )}
                </Tabs>
            </div>
        </article>
    );
};

export default AccountDetailsPage;
